const API_URL = process.env.REACT_APP_BACKEND_URL;

export const trackWhatsAppClick = (option, page, contact = '', language = 'it') => {
  fetch(`${API_URL}/api/track-whatsapp`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ option, page, contact, language }),
  }).catch(() => {});
};
